// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Htmq","index":"styles_index__3aEqd"};